import { Alert } from 'app/models/dto/alert.model';
import { NonOwnerPersonnel } from 'app/models/dto/non-owner-personnel.model';


export class SetNewNonOwnerPersonnel {
    static readonly type = '[NonOwnerPersonnel] SetNewNonOwnerPersonnel';
    constructor(public emailAddress?: string) {}
}

export class UnsetNewNonOwnerPersonnel {
    static readonly type = '[NonOwnerPersonnel] UnsetNewNonOwnerPersonnel';
    constructor() {}
}

export class CreateNonOwnerPersonnel {
    static readonly type = '[NonOwnerPersonnel] CreateNonOwnerPersonnel';
    constructor(public newNonOwnerPersonnel: NonOwnerPersonnel) {}
}

export class GetNonOwnerPersonnelForBorrower {
    static readonly type = '[NonOwnerPersonnel] GetNonOwnerPersonnelForBorrower';
    constructor(public borrowerId: number) {}
}

export class UpdateNonOwnerPersonnel {
    static readonly type = '[NonOwnerPersonnel] UpdateNonOwnerPersonnel';
    constructor(public nonOwnerPersonnel: NonOwnerPersonnel) {}
}

export class DeleteNonOwnerPersonnel {
    static readonly type = '[NonOwnerPersonnel] DeleteNonOwnerPersonnel';
    constructor(public id: number) {}
}

export class CreateNonOwnerPersonnelAlert {
    static readonly type = '[NonOwnerPersonnel] CreateNonOwnerPersonnelAlert';
    constructor(public alertLevel: any, public message: string) {}
}

export class DismissNonOwnerPersonnelAlert {
    static readonly type = '[NonOwnerPersonnel] DismissNonOwnerPersonnelAlert';
    constructor(public alert: Alert) {}
}

export class ClearNonOwnerPersonnelStore {
    static readonly type = '[NonOwnerPersonnel] ClearNonOwnerPersonnelStore';
    constructor() {}
}
